import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, forwardRef } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { MarvSelectComponent, MarvSelectItem } from '@marv/components';
import { MarvDateService } from '@marv/services';
import { OperationService, MissionTypeService } from '@app/services';

@Component({
    selector: 'app-operation-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    imports: [forwardRef(() => MarvSelectComponent)]
})
export class OperationSelectComponent  implements OnInit {

    @Input({alias : 'label', required : false}) labelSelect: string = this.translateService.instant('OPERATION');
    @Input({alias : 'icon', required : false}) iconSelect: string = 'briefcase-outline';
    @Input({alias : 'formName', required : false}) formName: string|number = 'operationId';
    @Input({alias : 'errorText', required : false}) errorText: string = '';
    @Input({alias : 'multiple', required : false}) multiple: boolean = false; 
    @Input({alias : 'displayItemsSelected', required : false}) displayItemsSelected: boolean = false;
    @Input({alias : 'operations', required : false}) operations: Array<MarvSelectItem>;
    @Input({alias : 'startDate', required : false}) startDate: Date;
    @Input({alias : 'endDate', required : false}) endDate: Date;
    @Input({alias : 'withSpeechToText', required : false}) withSpeechToText: boolean = false;

    @Output() onChangeItems = new EventEmitter<MarvSelectItem[]>();

    items: Array<MarvSelectItem> = [];

    constructor(
        public translateService: TranslateService,
        private missionTypeService: MissionTypeService
    ) { }

    async ngOnInit() {
        let items: Array<MarvSelectItem> = [];
        if(typeof this.operations !== 'undefined'){
            items = this.operations;
        }
        else{
            items = await this.getOperationsItems();
        }
        this.items = items;
    }
    
    async getOperationsItems() {
        let items: Array<MarvSelectItem> = [];        
        let operations = OperationService.Operations;
        if(operations){
            let startDate = (this.startDate ? MarvDateService.FromDate(this.startDate) : null );
            let endDate = (this.endDate ? MarvDateService.FromDate(this.endDate) : null );
            for(let operation of operations){ 
            
                let startDateOp = operation.planningOpenFrom;
                let endDateOp = operation.planningOpenUntil;
                
                if((!startDate || !endDate) || (startDate && endDate && ((!startDateOp || (startDateOp && startDateOp <= endDateOp)) || (!endDateOp || (endDateOp && endDateOp >= startDate))) )){
                    let keyOperation = operation.type+'|'+operation.id;
                    let item = new MarvSelectItem(operation.name, keyOperation);
                    item.color = this.missionTypeService.getColor(operation.typeOfMissionCode);
                    items.push(item);
                }
                                
            }
        }
        this.onChangeItems.emit(items);
        return items;
    }
    
    async ngOnChanges(changes: SimpleChanges) {     
        if(changes['operations'] && changes['operations'].currentValue){       
            if(typeof this.operations !== 'undefined'){
                 this.items = this.operations;
            }            
        }
        
        if( ((changes['startDate'] && changes['startDate'].currentValue)
            || (changes['endDate'] && changes['endDate'].currentValue))
            && typeof this.operations === 'undefined'){  
            this.items = await this.getOperationsItems();            
        }
        
    }

}
